
<div class="container">


  <h2 class="content-heading">
        <button class="btn btn-sm btn-outline-secondary float-right" (click)="add()">
           <i class="fa fa-plus mr-5"></i>Add
         </button>
       
         Psalter
   </h2>


 <div class="blockX"> 
   <!--
   <div class="block-header block-header-default">
       <h3 class="block-title"></h3>
   </div>
 -->
 <div style="padding-bottom:20px;"> 
   <app-psalter-search (searchItems)="search($event)"></app-psalter-search>
 </div>


 <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>

   <div  *ngIf="isLoading==false">

    <div *ngIf="entities != null && entities.length > 0">
       <div class=row>

           <div class="col-sm-5">

             Show
             <select (change)="changeNumberOfRecords()" [(ngModel)]="numberOfRecords">
               <option value=15>15</option>
                 <option value=30>30</option>
                 <option value=60>60</option>
                 <option value=99999>All</option>
             </select>
             entries  

         </div>
       
         <div class="col-sm-7 text-right"> 
           <span style="margin-right:20px">
             Proofed: 
             <select  (change)="changeProofedOption()" [(ngModel)]="searchProofed">
               <option [ngValue]=null></option>
               <option  [ngValue]=true>Yes</option>
               <option  [ngValue]=false>No</option>
             </select>
           </span>
             Filter: <input type="text" [(ngModel)]="searchFilter">
         </div>
         
       </div>

       <div class="table-responsive table yearDataTable">

           <div class="xrow header gridRow row"> 
               <div class="">Source</div>
               <div class="">C:V:P:L</div> 
               <div class="">Letter</div> 
               <div class="">HTML</div>
               <div class="">Space After</div>
               <div class="">Proofed</div>
               <div class=""></div>
           </div>

           <div id="scrollableTable">
               <div class="">

                   <div *ngFor="let obj of entities | psalterFilter: searchFilter : searchProofed | paginate: { itemsPerPage: numberOfRecords, currentPage: pageNumber }" class="dateRow gridRow row">
                   
                     <div class="">
                         {{obj.LectionarySourceName}}
                         <BR>
                         {{obj.LectionarySourcePageNumber}}
                     </div>
                     <div class="">{{obj.Chapter}}:{{obj.Verse}}:{{obj.Part}}:{{obj.Line}}</div>
                     <div class="">{{obj.Letter}}</div> 
                     <div class="">{{obj.Html}}</div> 
                     <div class="">
                      <span *ngIf="obj.IsSpaceAfter == true">Yes</span>
                      <span *ngIf="obj.IsSpaceAfter != true">No</span>
                     </div> 
                     <div class="">
                       <span *ngIf="obj.IsProofed == true">Yes</span>
                     </div> 

                   <div class=" text-right">

                           <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit" (click)="edit(obj)">
                               <i class="fa fa-pencil"></i>
                           </button>
                           <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Delete" (click)="delete(obj)">
                               <i class="fa fa-times"></i>
                           </button>
                        
                     </div>

               </div>
               </div>

           </div>




         </div>

  
<div id="pageButtons" style="overflow: auto">

 {{ renderPaginationItemStatus(p) }} of {{ p.getTotalItems()}} entries

 <pagination-template #p="paginationApi" (pageChange)="pageNumber = $event" class="float-right">
  
   <div class="custom-pagination">
 
     <ul class="pagination pagination">
   
       <li class="page-item">
         <a class="page-link" *ngIf="!p.isFirstPage()" (click)="p.previous();">
           <i class="fa fa-angle-double-left"></i>
         </a>
       </li>
 
       <li class="page-item" *ngFor="let page of p.pages" [class.active]="p.getCurrent() === page.value">
         <a class="page-link" (click)="p.setCurrent(page.value);" *ngIf="p.getCurrent() !== page.value">
           <span>{{ page.label }}</span>
         </a>
         <a class="page-link" *ngIf="p.getCurrent() === page.value">
           <span>{{ page.label }}</span>
         </a>
       </li>
 
       <li class="page-item">
         <a class="page-link"  *ngIf="!p.isLastPage()" (click)="p.next();">
             <i class="fa fa-angle-double-right"></i>
         </a>
       </li>


    
 
     </ul> 
 
   </div>
 
 </pagination-template>

 </div>

 <div>

     <div>
       Total Proofed: 
       {{countTotalProofed}}
     </div>
     <div>
       Total Not Proofed:
       {{countTotalNotProofed}}
     </div>
     
 </div>


   </div>

   <div *ngIf="entities == null">No entities from API</div>


   </div>

   

 </div>

 </div>
